import { Box } from "@mui/material"
import { styled } from "@mui/material/styles"
import { IIcon } from "./CircleIcon.interfaces"

const getSize = (size: string | undefined) => {
  switch (size) {
    case "xl":
      return "65px"
    case "lg":
      return "55px"
    case "md":
      return "50px"
    case "sm":
      return "40px"
    case "xs":
      return "15px"
    default:
      return "25px"
  }
}

export const StyledBox = styled(Box)<IIcon>(({ theme, size, backgroundColor }) => ({
  borderRadius: "100px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: getSize(size),
  width: getSize(size),
  backgroundColor:
    backgroundColor ?
      backgroundColor
      : (theme.palette as any).primary[300]
}))
